/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = NotSent
 *
 * 2 = Sent
 *
 * 3 = HasErrors
 *
 * 4 = Approved
 */
export enum SubmitStageStatus {
  NotSent = 1,
  Sent = 2,
  HasErrors = 3,
  Approved = 4,
}
